import { render, staticRenderFns } from "./ColumnPostStatus.vue?vue&type=template&id=0ac23dbc&"
import script from "./ColumnPostStatus.vue?vue&type=script&lang=js&"
export * from "./ColumnPostStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports